import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import SostaOnlineApiService from '../services/SostaOnlineApiService'
import BackOfficeUserDetailLogsTable from '../screens/BackOfficeUserDetailLogsTable'

const mapStateToProps = (state) => {
  return {
    state: state.users
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
  }
}

class BackOfficeUserDetailLogsTableContainer extends Component {
  static propTypes = {
    userId: PropTypes.number
  }

  constructor (props) {
    super(props)
    this.state = {
      logs: [],
      loading: false
    }

    this.fetchLogs = this.fetchLogs.bind(this)
  }

  componentDidMount () {
    this.fetchLogs()
  }

  fetchLogs () {
    this.setState({loading: true})

    console.log(this.props.userId)
    SostaOnlineApiService.fetchUserLogs(this.props.userId).then((data) => {
      this.setState({
        logs: data.data,
        loading: false
      })
    })
  }

  render () {
    return (
      <div>
        <BackOfficeUserDetailLogsTable
          loading={this.state.loading}
          logs={this.state.logs}
        />
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(BackOfficeUserDetailLogsTableContainer)
